var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 79.998,
    viewBox: "0 0 80 79.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2221",
    "data-name": "Group 2221",
    transform: "translate(-1076.648 -289.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M22.831,0a22.5,22.5,0,1,0,22.5,22.5A22.525,22.525,0,0,0,22.831,0Z",
    transform: "translate(1093.593 305.658)",
    fill: "#e3ddda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M188.645,188.041l-12.254,1.12-5.592-5.6a1.111,1.111,0,0,0-1.579,1.564l.007.007,5.961,5.968a1.111,1.111,0,0,0,.786.326c.033,0,.068,0,.1,0l12.773-1.168a1.111,1.111,0,0,0-.2-2.214Zm0,0",
    transform: "translate(939.694 138.47)",
    fill: "#535765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M39.755,3.838a36.1,36.1,0,0,1,18.5,5.227,39.917,39.917,0,0,1,10.072,8.6l-10.132-.333h-.058a1.716,1.716,0,0,0-.055,3.431l13.157.433a1.718,1.718,0,0,0,2.272-2.269l-.434-13.12a1.721,1.721,0,0,0-3.441.077.271.271,0,0,0,0,.036l.275,8.331a43.6,43.6,0,0,0-9.888-8.131A39.554,39.554,0,0,0,39.754.406,38.731,38.731,0,0,0,10.681,13.375,42.742,42.742,0,0,0,2.772,26.11,38.267,38.267,0,0,0,0,40.055a1.721,1.721,0,0,0,3.441,0c0-8.469,3.663-17.585,9.8-24.384A35.32,35.32,0,0,1,39.755,3.838Zm0,0",
    transform: "translate(1076.648 288.696)",
    fill: "#535765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M118.123,276.691a1.718,1.718,0,0,0-1.72,1.716c0,8.469-3.663,17.584-9.8,24.383a35.322,35.322,0,0,1-26.516,11.833,36.111,36.111,0,0,1-18.5-5.226,39.927,39.927,0,0,1-10.071-8.6l10.131.333a1.715,1.715,0,0,0,.113-3.429l-13.157-.433a1.718,1.718,0,0,0-2.271,2.269l.434,13.119a1.72,1.72,0,0,0,3.439-.077c0-.012,0-.025,0-.037l-.275-8.33a43.583,43.583,0,0,0,9.888,8.13,39.553,39.553,0,0,0,20.268,5.716,38.727,38.727,0,0,0,29.073-12.969,42.755,42.755,0,0,0,7.909-12.735,38.259,38.259,0,0,0,2.772-13.944,1.718,1.718,0,0,0-1.72-1.716Zm0,0",
    transform: "translate(1036.804 51.045)",
    fill: "#535765"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.f38afd139aa44fdda34e8e4c505b67d4.svg";
export { ForwardRef as ReactComponent };